import PropTypes from 'prop-types';
import React from 'react';
import { FLOW_NAVIGATION_ACTIONS } from '../../../../../flows/DynamicFlow/utilities/constants';
import * as ADDONS_COPY from '../../../../../pages/BirthdayPartyAddOns/utilities/copy';
import * as FOOD_DRINKS_COPY from '../../../../../pages/BirthdayPartyFoodAndDrinks/utilities/copy';
import { isArrayEmpty } from '../../../../../utilities/arraysUtils';
import { getCurrencyCodeText } from '../../../../../utilities/planUtils';
import SelectPackageQuantity from '../../../../Packages/SelectPackageQuantity';
import { Box, Text, TextLink } from '../../../../ui-kit';
import { editCopyByReplaceString } from '../../../../utilities/copyFunctions';
import { SummaryContent } from '../../Content';
import { ItemListWrapper } from '../assets/styles';
import * as COPY from '../utilities/copy';

const propTypes = {
  /** String date object with the checkin date */
  checkinDateSelection: PropTypes.string.isRequired,

  /** String date object with the checkout date */
  checkoutDateSelection: PropTypes.string.isRequired,

  /** Currenty selected packages */
  currentSelectedPackages: PropTypes.arrayOf(
    PropTypes.shape({
      packageCode: PropTypes.string,
      packageName: PropTypes.string,
      currencyCode: PropTypes.string,
      quantity: PropTypes.number,
      amount: PropTypes.number,
      isAdjustment: PropTypes.bool,
      showQuantitySelect: PropTypes.bool
    })
  ),

  /** Number of guests for the reservation */
  numberOfGuests: PropTypes.number.isRequired,

  /** Flag to indicate the property is in Niagara */
  isNiagaraProperty: PropTypes.bool,

  /** Function to update the package quantity */
  upsertPackage: PropTypes.func,

  /** Funtion to delete a package */
  deletePackage: PropTypes.func,

  /** Flag to indicate if the reservation has selected packages */
  hasSelectedPackages: PropTypes.bool
};

const getPackagePriceDisplay = packageItem =>
  `${(parseInt(packageItem.quantity || 1) * packageItem.amount).toFixed(2)}`;

const getBirthdayScreenSlug = summarySection => {
  switch (summarySection) {
    case ADDONS_COPY.PAGE_TITLE:
      return '/packages-addons';
    case FOOD_DRINKS_COPY.TITLE:
      return '/food-drinks';
    default:
      return null;
  }
};

const ListOfPackages = ({
  currentSelectedPackages,
  deletePackage,
  isNiagaraProperty,
  checkinDateSelection,
  checkoutDateSelection,
  numberOfGuests,
  updatePackageQuantity,
  allowPackageUpdate,
  isBirthdayPackage,
  isFoodAndDrinks
}) => {
  return (
    <ItemListWrapper allowPackageUpdate={allowPackageUpdate}>
      {currentSelectedPackages.map(item =>
        !item.isAdjustment ? (
          <SummaryContent.Item key={`packageCode-${item.packageCode}`}>
            <SummaryContent.Description lineHeight={'18px'}>
              {item.quantity ? `${item.quantity} ` : ''} {item.packageTitle || item.title}
            </SummaryContent.Description>
            {allowPackageUpdate && item.quantity && !item.packageType?.includes('dining') ? (
              <Box width="80px" style={{ textAlign: 'right' }}>
                <SelectPackageQuantity
                  isNiagaraProperty={isNiagaraProperty}
                  checkinDateSelection={checkinDateSelection}
                  checkoutDateSelection={checkoutDateSelection}
                  packageItem={item}
                  numberOfGuests={numberOfGuests}
                  updatePackageQuantity={updatePackageQuantity}
                />
              </Box>
            ) : null}
            {allowPackageUpdate ? (
              <SummaryContent.Action onClick={() => deletePackage(item)}>{COPY.REMOVE}</SummaryContent.Action>
            ) : null}

            <SummaryContent.Amount width={isBirthdayPackage && !item.isExtra ? 'auto' : 'initial'} fontSize={0}>
              {isBirthdayPackage && isFoodAndDrinks && !item.isExtra
                ? COPY.SUMMARY_INCLUDED
                : `$${getPackagePriceDisplay(item)} ${getCurrencyCodeText(item.currencyCode) || ''}`}
            </SummaryContent.Amount>
          </SummaryContent.Item>
        ) : null
      )}
    </ItemListWrapper>
  );
};

const PackagesList = ({
  checkinDateSelection,
  checkoutDateSelection,
  currentSelectedPackages,
  numberOfGuests,
  isNiagaraProperty,
  upsertPackage,
  deletePackage,
  splitPackagesByTabName,
  allowPackageUpdate,
  triggerDynamicStepNavigation,
  allowPackagesListLink
}) => {
  function updatePackageQuantity(e, packageItem) {
    upsertPackage({ ...packageItem, quantity: e.target.value });
  }

  let groupedPackagesByTabName = null;

  if (splitPackagesByTabName) {
    let groupedPackagesBySectionAndType = Object.groupBy(
      currentSelectedPackages,
      ({ summarySection }) => summarySection
    );

    Object.keys(groupedPackagesBySectionAndType).forEach(summarySectionKey => {
      groupedPackagesBySectionAndType[summarySectionKey] = Object.groupBy(
        groupedPackagesBySectionAndType[summarySectionKey],
        ({ summarySectionType }) => summarySectionType
      );
    });

    groupedPackagesByTabName = groupedPackagesBySectionAndType;
  }

  if (currentSelectedPackages && isArrayEmpty(currentSelectedPackages)) return null;

  return (
    <>
      {splitPackagesByTabName && groupedPackagesByTabName ? (
        <>
          {Object.entries(groupedPackagesByTabName).map(([summarySection, pkgsList]) => {
            return (
              <>
                <Text fontWeight="bold" fontSize={0} lineHeight={'16px'} capitalize color="deepLakeBlue.100" mb={1}>
                  {summarySection}
                </Text>
                {Object.keys(pkgsList).map(list => (
                  <ListOfPackages
                    currentSelectedPackages={pkgsList[list]}
                    deletePackage={deletePackage}
                    isNiagaraProperty={isNiagaraProperty}
                    checkinDateSelection={checkinDateSelection}
                    checkoutDateSelection={checkoutDateSelection}
                    numberOfGuests={numberOfGuests}
                    updatePackageQuantity={updatePackageQuantity}
                    allowPackageUpdate={allowPackageUpdate}
                    isBirthdayPackage={splitPackagesByTabName && groupedPackagesByTabName}
                    isFoodAndDrinks={summarySection.includes('&')}
                  />
                ))}

                {allowPackagesListLink ? (
                  <TextLink
                    capitalize
                    lineHeight={16}
                    fontSize={9}
                    fontWeight="bold"
                    onClick={() => {
                      !window.location.pathname.includes(getBirthdayScreenSlug(summarySection)) &&
                        triggerDynamicStepNavigation(
                          FLOW_NAVIGATION_ACTIONS.FLOW_TRIGGER_STEP_BY_SLUG,
                          getBirthdayScreenSlug(summarySection)
                        );
                    }}
                    mt={2}>
                    {editCopyByReplaceString(COPY.BIRTHDAY_LINK_TEXT, summarySection, '<LINK_TEXT>')}
                  </TextLink>
                ) : null}
                <SummaryContent.Divider />
              </>
            );
          })}
        </>
      ) : (
        <>
          <ListOfPackages
            currentSelectedPackages={currentSelectedPackages}
            deletePackage={deletePackage}
            isNiagaraProperty={isNiagaraProperty}
            checkinDateSelection={checkinDateSelection}
            checkoutDateSelection={checkoutDateSelection}
            numberOfGuests={numberOfGuests}
            updatePackageQuantity={updatePackageQuantity}
            allowPackageUpdate={allowPackageUpdate}
          />
          <SummaryContent.Divider />
        </>
      )}
    </>
  );
};

PackagesList.propTypes = propTypes;

PackagesList.defaultProps = {
  isNiagaraProperty: false,
  hasSelectedPackages: false
};

export default PackagesList;
